import { $http } from '@/utils';
import { kebabCase } from 'lodash';

/**
 * @namespace Service
 * @class Configuration
 * @exports Service/Cms/Site
 * @description API Configuration Service
 * @date 2021/04/01
 * @license no license
 * @copywrite Answers In Retirement Limited
 */
export default class Site {
	/**
	 * @static @name usingDomain
	 * @description Get Site
	 * @returns {Object} Promise a http response
	 */
	static get() {
		return $http.get(`cms/site`);
	}

	/**
	 * @name getDbContent
	 * @description Get db content
	 * @returns {Object} Promise a http response
	 */
	static getDbContent(name, domain) {
		const version = process.env?.VUE_APP_VERSION || null;
		return $http.get(`cms/db-content/${name}/${version}`, {
			cache: true,
			cachePath: `db-content-${kebabCase(name)}-${version}-${domain}`
		});
	}

	/**
	 * @name getCacheContent
	 * @description Get cache content
	 * @returns {Object} Promise a http response
	 */
	static getCacheContent(name) {
		return $http.get(`${process.env.VUE_APP_CACHE_URL}/${name}`, {
			cache: true,
			cachePath: name
		});
	}
}
